import http from "./http";

// 获取课程
export function getCourse(school , approved = '') {
  return new Promise((resolve, reject) => {
    http.get("/course?school=" + school + "&&approved=" + approved).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 创建课程
export function add_course_api(data = {}) {
  return new Promise((resolve, reject) => {
    http.post("/course", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 修改课程
export function putSubject(id, data = {}) {
  return new Promise((resolve, reject) => {
    http.put("/course?id=" + id, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 删除课程
export function delete_subject(id) {
  return new Promise((resolve, reject) => {
    http.delete("/course?id=" + id).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 创建课程章节
export function add_chapter_api(id, data = {}) {
  return new Promise((resolve, reject) => {
    http.post("/course/chapter?id=" + id, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 修改课程章节
export function edit_chapter_api(id, data = {}) {
  return new Promise((resolve, reject) => {
    http.put("/course/chapter?id=" + id, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 删除课程章节
export function delete_chapter_api(id) {
  return new Promise((resolve, reject) => {
    http.delete("/course/chapter?id=" + id).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 创建章节讲义
export function add_handout_api(id, data = {}) {
  return new Promise((resolve, reject) => {
    http
      .post("/course/chapter/handout?chapter=" + id, data)
      .then(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
  });
}

// 修改章节讲义
export function edit_handout_api(id, data = {}) {
  return new Promise((resolve, reject) => {
    http.put("/course/chapter/handout?handout=" + id, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 删除章节讲义
export function delete_handout_api(id) {
  return new Promise((resolve, reject) => {
    http.delete("/course/chapter/handout?handout=" + id).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
